import {
  Text,
  Placeholder,
  withDatasourceCheck,
  TextField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'src/hooks/helpers';

type Fields = {
  heading: TextField;
  description: TextField;
};
type HighlightBlockProps = ComponentProps & {
  fields: Fields;
};

const HighlightBlock = ({ fields, rendering, params }: HighlightBlockProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  const { sitecoreContext } = useSitecoreContext();
  const isExperienceEditor = sitecoreContext.pageEditing;
  return (
    <div
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className={`highlight-block py-3 mt-5 col-xl-8 ${[params.background]}`}
    >
      <div className="container px-3">
        {isExperienceEditor ||
          (fields && fields.heading && (
            <Text tag="h3" field={fields.heading} className="section-header-large mb-4" />
          ))}
        <Text tag="p" field={fields.description} className="body-default text-grey" />
        <Placeholder name="abrdn-highlight-block" rendering={rendering} className="mt-3" />
      </div>
    </div>
  );
};

export default withDatasourceCheck()<HighlightBlockProps>(HighlightBlock);
